// extracted by mini-css-extract-plugin
export var modal = "_tm-0";
export var table = "_tm-1";